import accordion from "../../modules/accordion/accordion";
import calloutInteractive from "../../modules/callout-interactive/callout-interactive";
import calloutThreeUp from "../../modules/callout-three-up/callout-three-up";
import cartGrid from "../../modules/cart-grid/cart-grid";
import headerCartIcon from "../../modules/header-cart-icon/header-cart-icon";
import headerMega from "../../modules/header-mega/header-mega";
import hero from "../../modules/hero/hero";
import heroMain from "../../modules/hero-main/hero-main";
import heroSecondary from "../../modules/hero-secondary/hero-secondary";
import image from "../../modules/image/image";
import loadingAnimation from "../../modules/loading-animation/loading-animation";
import miniCart from "../../modules/mini-cart/mini-cart";
import modal from "../../modules/modal/modal";
import productAccordion from "../../modules/product-accordion/product-accordion";
import productForm from "../../modules/product-form/product-form";
import productMain from "../../modules/product-main/product-main";
import newsletterForm from "../../modules/newsletter-form/newsletter-form";
import ProductCard from "../../modules/product-card/product-card.vue";
import productSlideOut from "../../modules/product-slide-out/product-slide-out";
import productThreeUp from "../../modules/product-three-up/product-three-up";
import promoBar from "../../modules/promo-bar/promo-bar";
import threeUp from "../../modules/three-up/three-up";
import video from "../../modules/video/video";

function init(ctx: Document | Element = document) {
  const modules = ctx.querySelectorAll("[data-module]");
  modules.forEach((module) => {
    let moduleName: string | undefined = undefined;
    try {
      moduleName = (module as HTMLElement).dataset.module;

      if (!moduleName) {
        return;
      }

      switch (moduleName) {
        case "accordion":
          accordion(module as HTMLElement);
          break;
        case "callout-interactive":
          calloutInteractive(module as HTMLElement);
          break;
        case "callout-three-up":
          calloutThreeUp(module as HTMLElement);
          break;
        case "cart-grid":
        case "cart-grid-bb":
          cartGrid(module as HTMLElement);
          break;
        case "newsletter-form":
          newsletterForm(module as HTMLElement);
          break;
        case "header-cart-icon":
          headerCartIcon(module as HTMLElement);
          break;
        case "header-mega":
          headerMega(module as HTMLElement);
          break;
        case "hero":
          hero(module as HTMLElement);
          break;
        case "hero-main":
          heroMain(module as HTMLElement);
          break;
        case "hero-secondary":
          heroSecondary(module as HTMLElement);
          break;
        case "image":
          image(module as HTMLElement);
          break;
        case "loading-animation":
          loadingAnimation(module as HTMLElement);
          break;
        case "mini-cart":
          miniCart(module as HTMLElement);
          break;
        case "modal":
          modal(module as HTMLElement);
          break;
        case "product-accordion":
          productAccordion(module as HTMLElement);
          break;
        case "product-card":
          ProductCard(module as HTMLElement);
          break;
        case "product-form":
          productForm(module as HTMLElement);
          break;
        case "product-main":
          productMain(module as HTMLElement);
          break;
        case "product-slide-out":
          productSlideOut(module as HTMLElement);
          break;
        case "product-three-up":
          productThreeUp(module as HTMLElement);
          break;
        case "promo-bar":
          promoBar();
          break;
        case "three-up":
          threeUp(module as HTMLElement);
          break;
        case "video":
          video(module as HTMLElement);
          break;
      }
    } catch (error) {
      console.log("error rendering module", moduleName, error);
      console.error(error);
    }
  });
}

export { init };
export default init;
